import React, { useState } from "react";
import Image from "components/image";
import Link from "components/link";
import { PortableText } from "@portabletext/react";
import ButtonLink from "components/button-link";
import Collapsible from "components/collapsible";
import MediaWithText from "components/media-with-text";
import ReadMore from "components/read-more";
import clsx from "clsx/lite";
import { ReactComponent as ArrowRight } from "svgs/right-arrow.svg";

const AccordionsItems = ({ value }) => {
	const [activeAccordionKey, setActiveAccordionKey] = useState(null);

	const setActiveAccordion = (key) => {
		setActiveAccordionKey((prev) => prev !== key ? key : null);
	};

	return (
		<div>
			{value?.items?.map((value) => (
				<Collapsible
					key={value._key} // Make sure to provide a unique key for each Collapsible
					title={<h5 className="py-2 text-start font-base font-semibold">{value.title}</h5>}
					contentClass={`pl-3 ${activeAccordionKey === value._key ? "pb-6" : "pb-0"}`}
					isOpen={activeAccordionKey === value._key}
					label={value.title}
					setIsOpen={() => setActiveAccordion(value._key)}
				>
					<RichText data={value} />
				</Collapsible>
			))}
		</div>
	);
};

const ArrowList = ({ children }) => {  
	return (
		<ul className="space-y-4">
			{React.Children.map(children, (child, i) => (
				<div key={i} className="relative flex items-center">
					<span className="absolute left-0 top-1/2 -translate-y-1/2">
						  <ArrowRight className="w-4 h-4 md:size-4 text-darkGray" />
					</span>
					<div className="pl-6 list-none text-base font-semibold">{child}</div>
		  </div>
			))}
	  </ul>
	);
};
  

const Video = ({ value }) => {
	const { controls = true, autoplay = true, muted = true, loop = true, videoUrl } = value;
	return (
		<video className="w-full py-4" controls={controls} autoPlay={autoplay} muted={muted} loop={loop}>
			<source src={videoUrl} type="video/mp4" />
			Your browser does not support HTML5 video.
		</video>
	);
};

//Types
const ImageRenderer = ({ value: node }) => <Image image={node} alt={node.alt} />;

const ButtonRenderer = ({ value: node }) => (
	<ButtonLink data={node} />
);

const MediaWithTextRenderer = ({ value }) => <MediaWithText data={value} />;

// Marks
const Links = ({ children, value }) => <Link to={value.href} isTargetBlank={value.openInNewTab}>{children}</Link>;

const Color = ({ children, value }) => <span className="text-unset" style={{ color: value?.color?.hex }}>{children}</span>;

const CenterText = ({ children }) => <span className="text-center">{children}</span>;

const richTextComponents = {
	types: {
		// table: TableSerializer,
		customImage: ImageRenderer,
		customImageNoUrl: ImageRenderer,
		button: ButtonRenderer,
		Video: Video,
		accordionsItems: AccordionsItems,
		mediaWithText: MediaWithTextRenderer,
	},
	marks: {
		link: Links,
		highlight: Color,
		center: CenterText,
	},
	list: {
		arrow: ArrowList,
	},
	hardBreak: () => <span className="flex h-3" />,
};

const RichText = ({ data, showReadMore = false }) => {
	if (!data?.content?.length) return null;

	return (
		<div className={clsx("rich-text", data?.centerAlign && "max-w-screen-md mx-auto justify-items-center")}>
			{showReadMore ? (
				<ReadMore><PortableText value={data.content} components={richTextComponents} /></ReadMore>
			) : (
				<PortableText value={data.content} components={richTextComponents} />
			)}
		</div>
	);
};

export default RichText;
